module.exports = __webpack_public_path__ + "img/54c5ef350b7148bda79882f2026f5306-60.b1a4f9fd.jpg";